<h1 mat-dialog-title>Are you absolutely sure?</h1>
@if (client$ | async; as client) {
    <div mat-dialog-content class="flex column">
        <div class="info">It is important to read this before continuing</div>
        @if (data) {
            <p>
                This action <b>cannot</b> be undone. This will permanently delete the
                <b>{{ client.config.data.name }}</b> workspace and all content contained within it.
            </p>
        } @else {
            <p>
                This action <b>cannot</b> be undone. this will remove all users except the admin and
                reduce the storage limit back to 1GB. If you have more content than that, you will
                be unable to upload new content.
            </p>
        }
        <p>
            Please type <b>{{ client.config.data.name }}</b> to confirm.
        </p>
        <mat-form-field appearance="fill">
            <input matInput required [formControl]="confirmControl" />
        </mat-form-field>
    </div>
}
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    @if (data) {
        <button
            mat-stroked-button
            color="warn"
            [disabled]="!confirmControl.valid"
            (click)="confirm()"
        >
            I understand the consequences, delete this workspace
        </button>
    } @else {
        <button
            mat-stroked-button
            color="warn"
            [disabled]="!confirmControl.valid"
            (click)="confirm()"
        >
            I understand the consequences, cancel my subscription
        </button>
    }
    <ng-template #cancel>
        <button
            mat-stroked-button
            color="warn"
            [disabled]="!confirmControl.valid"
            (click)="confirm()"
        >
            I understand the consequences, cancel my subscription
        </button>
    </ng-template>
</div>
